import {
  getDeviceLayout,
  getIsReturningUser,
  getUserCountryCode
} from 'modules/meta/selectors'
import {AppLockedDealConfig} from 'modules/search/slice'
import {getIsCountryExcludedFromAppLockedDeals} from 'utils/countriesExcludedFromAppLockedDeals'
import {getIsFromGha} from 'utils/trafficSource'

import {Placement} from '@vio/core/src/deepLinking/types'

// eslint-disable-next-line no-restricted-imports
import type {toggle as toggleType} from 'opticks'
import type {RootState} from 'store'

/**
 * Get the app locked deal audience config for anchor hotels
 */
export const decideAppLockedDealAnchorAudienceConfig = (
  state: RootState,
  toggle: typeof toggleType
): AppLockedDealConfig => {
  // Input data, we also rely on segmentation attributes for the toggles below
  const userCountryCode = getUserCountryCode(state)
  const isReturningUser = getIsReturningUser(state)
  const deviceLayout = getDeviceLayout(state)
  const isFromGha = getIsFromGha(state)

  // Toggles & holdouts
  const userCountryIsExcludedFromAppLockedDeals =
    getIsCountryExcludedFromAppLockedDeals(userCountryCode)
  const isWebToAppFeatureEnabled =
    deviceLayout === 'mobile' &&
    toggle('feature-web-to-app-mobile-anchor', false, true)
  const isHoldOutGroupEnabled = toggle(
    'h02hslwa-app-exclusive-deal-hold-out-group',
    false,
    true
  )

  if (
    userCountryIsExcludedFromAppLockedDeals ||
    !isWebToAppFeatureEnabled ||
    isHoldOutGroupEnabled
  ) {
    return {isAppLockedDealAudience: false}
  }

  if (isReturningUser || isFromGha) {
    return {
      isAppLockedDealAudience: true,
      placement: Placement.AnchorAppLockedDeal
    }
  }
  return {
    isAppLockedDealAudience: false
  }
}

/**
 * Get the app locked deal audience config for non-anchor hotels
 */
export const decideAppLockedDealNonAnchorAudienceConfig = (
  state: RootState,
  toggle: typeof toggleType
): AppLockedDealConfig => {
  const deviceLayout = getDeviceLayout(state)

  const isWebToAppFeatureEnabled =
    deviceLayout === 'mobile' &&
    toggle('feature-web-to-app-mobile-non-anchor', false, true)
  const isHoldOutGroupEnabled = toggle(
    'h02hslwa-app-exclusive-deal-hold-out-group',
    false,
    true
  )

  if (!isWebToAppFeatureEnabled || isHoldOutGroupEnabled) {
    return {isAppLockedDealAudience: false}
  }
  return {
    isAppLockedDealAudience: true,
    placement: Placement.NonAnchorAppLockedDeal
  }
}
